import React from 'react';
import isEmpty from 'lodash/isEmpty';
import DelayedAutoComplete from '../DelayedAutoComplete';
import { suggestAutoComplete } from '../../../services/auto-complete';
import { connect } from 'react-redux';
import { updateCurrentQueryDetiails } from '../../../actions/query';
import { Dispatch, QueryRequest, store } from '../../../utils/types';
import { Form } from 'antd';

const MAX_TAGS_COUNT = 5;

const SearchTags = ({ values, setValues }: any) => {
  const onChange = (tags: string[]) => {
    if (tags.length <= MAX_TAGS_COUNT) {
      setValues({ ...values, search: tags });
    }
  };

  return (
    <div id="search-tags" className="w-full mt-5">
      <Form.Item
        labelCol={{ span: 24 }}
        label={`Species Name (Up to ${MAX_TAGS_COUNT})`}
      >
        <DelayedAutoComplete
          disabled={isEmpty(values.categoryId)}
          value={values.search}
          onChange={onChange}
          delay={200}
          fetchMethod={suggestAutoComplete}
          fetchMethodExtraArgs={{ categoryId: values.categoryId }} // get cohort disease id
        />
      </Form.Item>
    </div>
  );
};

const mapStateToProps = (state: store) => ({
  values: state.query.currentQueryDetails,
});

const mapDispatchToProps = (dispatch: Dispatch) => ({
  setValues: (currentQueryDetails: QueryRequest) =>
    dispatch(updateCurrentQueryDetiails(currentQueryDetails)),
});

export default connect(mapStateToProps, mapDispatchToProps)(SearchTags);
